import { render, staticRenderFns } from "./StatsMenagement.vue?vue&type=template&id=33aa49ca&scoped=true"
import script from "./StatsMenagement.vue?vue&type=script&lang=js"
export * from "./StatsMenagement.vue?vue&type=script&lang=js"
import style0 from "./StatsMenagement.vue?vue&type=style&index=0&id=33aa49ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aa49ca",
  null
  
)

export default component.exports